import analytics from "./index.mjs";
function trackABTestAssigned(payload) {
  analytics.pushEvent("ABTestAssigned", payload);
}
function trackCanCreateShortcutAsyncFailure(error, payload) {
  analytics.pushError("CanCreateShortcutAsyncFailure", error, payload);
}
function trackCanSubscribeBotSuccess(payload) {
  analytics.pushEvent("CanSubscribeBotSuccess", payload);
}
function trackCanSubscribeBotFailed(error, payload) {
  analytics.pushError("CanSubscribeBotFailed", error, payload);
}
function trackCDNPerformance(payload) {
  analytics.pushEvent("CDNPerformance", payload);
}
function trackCheckCanPlayerMatchAsyncFailure(error, payload) {
  analytics.pushError("CheckCanPlayerMatchAsyncFailure", error, payload);
}
function trackChooseAsync(payload) {
  analytics.pushEvent("ChooseAsync", payload);
}
function trackChooseAsyncSuccess(payload) {
  analytics.pushEvent("ChooseAsyncSuccess", payload);
}
function trackChooseAsyncFailed(error, payload) {
  analytics.pushError("ChooseAsyncFailed", error, payload);
}
function trackConsumePurchaseAsync(payload) {
  analytics.pushEvent("ConsumePurchaseAsyncSuccess", payload);
}
function trackConsumePurchaseAsyncFailure(error, payload) {
  analytics.pushError("ConsumePurchaseAsyncFailure", error, payload);
}
function trackConsumingPurchasesFailed(error) {
  analytics.pushError("consumingPurchasesFailed", error);
}
function trackCreateAsync(payload) {
  analytics.pushEvent("CreateAsync", payload);
}
function trackCreateAsyncSuccess(payload) {
  analytics.pushEvent("CreateAsyncSuccess", payload);
}
function trackCreateAsyncFailed(error, payload) {
  analytics.pushError("CreateAsyncFailed", error, payload);
}
function trackCreateShortcut(payload) {
  analytics.pushEvent("CreateShortcut", payload);
}
function trackCreateShortcutSuccess(payload) {
  analytics.pushEvent("CreateShortcutSuccess", payload);
}
function trackCreateShortcutFailure(error, payload) {
  analytics.pushError("CreateShortcutFailure", error, payload);
}
function trackDebugSendMessageAsync(payload) {
  analytics.pushEvent("DebugSendMessageAsync", payload);
}
function trackDebugUploadMessageImage(payload) {
  analytics.pushEvent("DebugUploadMessageImage", payload);
}
function trackEntryFailed(error) {
  analytics.pushError("EntryFailed", error);
}
function trackFirstScreenTap(payload) {
  analytics.pushEvent("FirstScreenTap", payload);
}
function trackFirstButtonTap(payload) {
  analytics.pushEvent("FirstButtonTap", payload);
}
function trackGetAllFriendsSuccess(payload) {
  analytics.pushEvent("GetAllFriendsSuccess", payload);
}
function trackGetAllFriendsFailed(error, payload) {
  analytics.pushError("GetAllFriendsFailed", error, payload);
}
function trackPinch(payload) {
  analytics.pushEvent("Pinch", payload);
}
function trackPinchConversion(payload) {
  analytics.pushEvent("PinchConversion", payload);
}
function trackGetASIDAsyncFailure(error, payload) {
  analytics.pushError("GetASIDAsyncFailure", error, payload);
}
function trackGetCatalogAsyncFailed(error, payload) {
  analytics.pushError("getCatalogAsyncFailed", error, payload);
}
function trackGetConnectedPlayersSuccess(payload) {
  analytics.pushEvent("GetConnectedPlayersSuccess", payload);
}
function trackGetConnectedPlayersFailed(error, payload) {
  analytics.pushError("GetConnectedPlayersFailed", error, payload);
}
function trackGetContextPlayersAsyncFailure(error, payload) {
  analytics.pushError("GetContextPlayersAsyncFailure", error, payload);
}
function trackGetDataAsyncFailed(error, payload) {
  analytics.pushError("GetDataAsyncFailed", error, payload);
}
function trackGetEntryPointAsyncFailure(error, payload) {
  analytics.pushError("GetEntryPointAsyncFailure", error, payload);
}
function trackGetEntryTimestampsFailure(error, payload) {
  analytics.pushError("GetEntryTimestampsFailure", error, payload);
}
function trackGetPlayerSquadsAsyncFailure(error, payload) {
  analytics.pushError("GetPlayerSquadsAsyncFailure", error, payload);
}
function trackGetPurchasesAsyncFailure(error, payload) {
  analytics.pushError("GetPurchasesAsyncFailure", error, payload);
}
function trackGetSignedPlayerInfoAsyncFailure(error, payload) {
  analytics.pushError("GetSignedPlayerInfoAsyncFailure", error, payload);
}
function trackCanUseSquadsAsyncFailure(error, payload) {
  analytics.pushError("CanUseSquadsAsyncFailure", error, payload);
}
function trackGetSquadAsyncFailure(error, payload) {
  analytics.pushError("GetSquadAsyncFailure", error, payload);
}
function trackCreateSquadAsync(payload) {
  analytics.pushEvent("CreateSquadAsync", payload);
}
function trackCreateSquadAsyncSuccess(payload) {
  analytics.pushEvent("CreateSquadAsyncSuccess", payload);
}
function trackCreateSquadAsyncFailure(error, payload) {
  analytics.pushError("CreateSquadAsyncFailure", error, payload);
}
function trackJoinSquadAsync(payload) {
  analytics.pushEvent("JoinSquadAsync", payload);
}
function trackJoinSquadAsyncSuccess(payload) {
  analytics.pushEvent("JoinSquadAsyncSuccess", payload);
}
function trackJoinSquadAsyncFailure(error, payload) {
  analytics.pushError("JoinSquadAsyncFailure", error, payload);
}
function trackGetTournamentAsyncFailure(error, payload) {
  analytics.pushError("GetTournamentAsyncFailure", error, payload);
}
function trackInviteAsync(payload) {
  analytics.pushEvent("InviteAsync", payload);
}
function trackInviteAsyncSuccess(payload) {
  analytics.pushEvent("InviteAsyncSuccess", payload);
}
function trackInviteAsyncFailure(error, payload) {
  analytics.pushError("InviteAsyncFailure", error, payload);
}
function trackMatchPlayerAsyncStart(payload) {
  analytics.pushEvent("MatchPlayerAsyncStart", payload);
}
function trackMatchPlayerAsyncSuccess(payload) {
  analytics.pushEvent("MatchPlayerAsyncSuccess", payload);
}
function trackMatchPlayerAsyncFailure(error, payload) {
  analytics.pushError("MatchPlayerAsyncFailure", error, payload);
}
function trackPlatformInitFailed(error) {
  analytics.pushError("PlatformInitFailed", error);
}
function trackPlatformInitSuccess() {
  analytics.pushEvent(
    "PlatformInitSuccess",
    null,
    analytics.toDefaultAndAdServer
  );
}
function trackPostSessionScoreAsyncSuccess(payload) {
  analytics.pushEvent("PostSessionScoreAsyncSuccess", payload);
}
function trackPostSessionScoreAsyncFailure(error, payload) {
  analytics.pushError("PostSessionScoreAsyncFailure", error, payload);
}
function trackPostTournamentScoreAsyncSuccess(payload) {
  analytics.pushEvent("PostTournamentScoreAsyncSuccess", payload);
}
function trackPostTournamentScoreAsyncFailure(error, payload) {
  analytics.pushError("PostTournamentScoreAsyncFailure", error, payload);
}
function trackCreateTournamentAsync(payload) {
  analytics.pushEvent("CreateTournamentAsync", payload);
}
function trackCreateTournamentAsyncSuccess(payload) {
  analytics.pushEvent("CreateTournamentAsyncSuccess", payload);
}
function trackCreateTournamentAsyncFailure(error, payload) {
  analytics.pushError("CreateTournamentAsyncFailure", error, payload);
}
function trackShareTournamentAsync(payload) {
  analytics.pushEvent("ShareTournamentAsync", payload);
}
function trackShareTournamentAsyncSuccess(payload) {
  analytics.pushEvent("ShareTournamentAsyncSuccess", payload);
}
function trackShareTournamentAsyncFailure(error, payload) {
  analytics.pushError("ShareTournamentAsyncFailure", error, payload);
}
function trackPayloadReadFailure(error, payload) {
  analytics.pushError("PayloadReadFailure", error, payload);
}
function trackPurchaseAsyncSuccess(payload) {
  analytics.pushEvent("PurchaseAsyncSuccess", payload);
}
function trackPurchaseAsyncFailed(error, payload) {
  analytics.pushError("purchaseAsyncFailed", error, payload);
}
function trackRedirectToLineOfficialAccount(payload) {
  analytics.pushEvent("RedirectToLineOfficialAccount", payload);
}
function trackRedirectToLineOfficialAccountFailure(error, payload) {
  analytics.pushError("RedirectToLineOfficialAccountFailure", error, payload);
}
function trackSendMessageAsyncSuccess(payload) {
  analytics.pushEvent("SendMessageAsyncSuccess", payload);
}
function trackSendMessageAsyncFailure(error, payload) {
  analytics.pushError("SendMessageAsyncFailure", error, payload);
}
function trackSendRawAnalyticsEventFailure(error, payload) {
  analytics.pushError("SendRawAnalyticsEventFailure", error, payload);
}
function trackSetDataAsyncFailed(error, payload) {
  analytics.pushError("SetDataAsyncFailed", error, payload);
}
function trackShareAsync(payload) {
  analytics.pushEvent("ShareAsync", payload);
}
function trackShareAsyncSuccess(payload) {
  analytics.pushEvent("ShareAsyncSuccess", payload);
}
function trackShareAsyncFailed(error, payload) {
  analytics.pushError("ShareAsyncFailed", error, payload);
}
function trackShareLinkAsync(payload) {
  analytics.pushEvent("ShareLinkAsync", payload);
}
function trackShareLinkAsyncSuccess(payload) {
  analytics.pushEvent("ShareLinkAsyncSuccess", payload);
}
function trackShareLinkAsyncFailure(error, payload) {
  analytics.pushError("ShareLinkAsyncFailure", error, payload);
}
function trackShareStoryAsync(payload) {
  analytics.pushEvent("ShareStoryAsync", payload);
}
function trackShareStoryAsyncSuccess(payload) {
  analytics.pushEvent("ShareStoryAsyncSuccess", payload);
}
function trackShareStoryAsyncFailure(error, payload) {
  analytics.pushError("ShareStoryAsyncFailure", error, payload);
}
function trackShowToSUpdatePopupAsync(payload) {
  analytics.pushEvent("ShowToSUpdatePopupAsync", payload);
}
function trackShowToSUpdatePopupAsyncSuccess(payload) {
  analytics.pushEvent("ShowToSUpdatePopupAsyncSuccess", payload);
}
function trackSubscribeBotAsync(payload) {
  analytics.pushEvent("SubscribeBotAsync", payload);
}
function trackSubscribeBotAsyncSuccess(payload) {
  analytics.pushEvent("SubscribeBotAsyncSuccess", payload);
}
function trackSubscribeBotAsyncFailure(error, payload) {
  analytics.pushError("SubscribeBotAsyncFailure", error, payload);
}
function trackSwitchAsync(payload) {
  analytics.pushEvent("SwitchAsync", payload);
}
function trackSwitchAsyncSuccess(payload) {
  analytics.pushEvent("SwitchAsyncSuccess", payload);
}
function trackSwitchAsyncFailed(error, payload) {
  analytics.pushError("SwitchAsyncFailed", error, payload);
}
function trackSwitchGameAsync(payload) {
  analytics.pushEvent("SwitchGameAsync", payload);
}
function trackSwitchGameAsyncFailed(error, payload) {
  analytics.pushError("SwitchGameAsyncFailed", error, payload);
}
function trackUnexpectedPurchase(purchase) {
  analytics.pushEvent("UnexpectedPurchase", purchase);
}
function trackCanSwitchNativeGameAsyncSuccess(payload) {
  analytics.pushEvent("CanSwitchNativeGameAsyncSuccess", payload);
}
function trackSwitchNativeGameAsync(payload) {
  analytics.pushEvent("SwitchNativeGameAsync", payload);
}
function trackCanSwitchNativeGameAsyncFailure(error, payload) {
  analytics.pushError("CanSwitchNativeGameAsyncFailure", error, payload);
}
function trackSwitchNativeGameAsyncFailure(error, payload) {
  analytics.pushError("SwitchNativeGameAsyncFailure", error, payload);
}
function trackUpdateAsyncSuccess(payload) {
  analytics.pushEvent("UpdateAsyncSuccess", payload);
}
function trackUpdateAsyncFailed(error, payload) {
  analytics.pushError("UpdateAsyncFailed", error, payload);
}
function trackUploadMessageImageSuccess(payload) {
  analytics.pushEvent("UploadMessageImageSuccess", payload);
}
function trackUploadMessageImageFailure(error, payload) {
  analytics.pushError("UploadMessageImageFailure", error, payload);
}
function trackVisibilityChange(payload) {
  analytics.pushEvent("VisibilityChange", payload);
}
function trackMarketingPostbackFailure(error, payload) {
  analytics.pushError("MarketingPostbackFailure", error, payload);
}
function trackGetAffinitySortedFriendIdsAsyncFailure(error) {
  analytics.pushError("GetAffinitySortedFriendIdsAsyncFailure", error);
}
export {
  trackABTestAssigned,
  trackCDNPerformance,
  trackCanCreateShortcutAsyncFailure,
  trackCanSubscribeBotFailed,
  trackCanSubscribeBotSuccess,
  trackCanSwitchNativeGameAsyncFailure,
  trackCanSwitchNativeGameAsyncSuccess,
  trackCanUseSquadsAsyncFailure,
  trackCheckCanPlayerMatchAsyncFailure,
  trackChooseAsync,
  trackChooseAsyncFailed,
  trackChooseAsyncSuccess,
  trackConsumePurchaseAsync,
  trackConsumePurchaseAsyncFailure,
  trackConsumingPurchasesFailed,
  trackCreateAsync,
  trackCreateAsyncFailed,
  trackCreateAsyncSuccess,
  trackCreateShortcut,
  trackCreateShortcutFailure,
  trackCreateShortcutSuccess,
  trackCreateSquadAsync,
  trackCreateSquadAsyncFailure,
  trackCreateSquadAsyncSuccess,
  trackCreateTournamentAsync,
  trackCreateTournamentAsyncFailure,
  trackCreateTournamentAsyncSuccess,
  trackDebugSendMessageAsync,
  trackDebugUploadMessageImage,
  trackEntryFailed,
  trackFirstButtonTap,
  trackFirstScreenTap,
  trackGetASIDAsyncFailure,
  trackGetAffinitySortedFriendIdsAsyncFailure,
  trackGetAllFriendsFailed,
  trackGetAllFriendsSuccess,
  trackGetCatalogAsyncFailed,
  trackGetConnectedPlayersFailed,
  trackGetConnectedPlayersSuccess,
  trackGetContextPlayersAsyncFailure,
  trackGetDataAsyncFailed,
  trackGetEntryPointAsyncFailure,
  trackGetEntryTimestampsFailure,
  trackGetPlayerSquadsAsyncFailure,
  trackGetPurchasesAsyncFailure,
  trackGetSignedPlayerInfoAsyncFailure,
  trackGetSquadAsyncFailure,
  trackGetTournamentAsyncFailure,
  trackInviteAsync,
  trackInviteAsyncFailure,
  trackInviteAsyncSuccess,
  trackJoinSquadAsync,
  trackJoinSquadAsyncFailure,
  trackJoinSquadAsyncSuccess,
  trackMarketingPostbackFailure,
  trackMatchPlayerAsyncFailure,
  trackMatchPlayerAsyncStart,
  trackMatchPlayerAsyncSuccess,
  trackPayloadReadFailure,
  trackPinch,
  trackPinchConversion,
  trackPlatformInitFailed,
  trackPlatformInitSuccess,
  trackPostSessionScoreAsyncFailure,
  trackPostSessionScoreAsyncSuccess,
  trackPostTournamentScoreAsyncFailure,
  trackPostTournamentScoreAsyncSuccess,
  trackPurchaseAsyncFailed,
  trackPurchaseAsyncSuccess,
  trackRedirectToLineOfficialAccount,
  trackRedirectToLineOfficialAccountFailure,
  trackSendMessageAsyncFailure,
  trackSendMessageAsyncSuccess,
  trackSendRawAnalyticsEventFailure,
  trackSetDataAsyncFailed,
  trackShareAsync,
  trackShareAsyncFailed,
  trackShareAsyncSuccess,
  trackShareLinkAsync,
  trackShareLinkAsyncFailure,
  trackShareLinkAsyncSuccess,
  trackShareStoryAsync,
  trackShareStoryAsyncFailure,
  trackShareStoryAsyncSuccess,
  trackShareTournamentAsync,
  trackShareTournamentAsyncFailure,
  trackShareTournamentAsyncSuccess,
  trackShowToSUpdatePopupAsync,
  trackShowToSUpdatePopupAsyncSuccess,
  trackSubscribeBotAsync,
  trackSubscribeBotAsyncFailure,
  trackSubscribeBotAsyncSuccess,
  trackSwitchAsync,
  trackSwitchAsyncFailed,
  trackSwitchAsyncSuccess,
  trackSwitchGameAsync,
  trackSwitchGameAsyncFailed,
  trackSwitchNativeGameAsync,
  trackSwitchNativeGameAsyncFailure,
  trackUnexpectedPurchase,
  trackUpdateAsyncFailed,
  trackUpdateAsyncSuccess,
  trackUploadMessageImageFailure,
  trackUploadMessageImageSuccess,
  trackVisibilityChange
};
